import { useEffect, useContext, useRef } from "react"
import { Box, Button, Skeleton, IconButton } from "@mui/material"
import { ArrowBack } from '@mui/icons-material'
import { Tabs } from "./tabs/Index"
import { Confirmation } from '../../../../../core/global/Confirmation'
import { ToolContext } from "../../../../../core/context/ToolContext"
import { S3 } from "../../../../../core/transmit/S3"
import { InputsErrMsg } from "../../../../../core/global/InputErrMsg"
import { useHistory } from "react-router-dom"
import { rqx } from "../../../../../core/request/API"
import { env } from "../../../../../core/Env"
import { toPng } from 'html-to-image';
import Preview from "./Preview"
import isEqual from "lodash/isEqual";

export const TrainingCustomPoster = () => {
    const { marketing_camp, tool_state } = useContext(ToolContext)
    const { trngModals, trngLoaders, trngSavingType, trngForm, trngError, trngSlctdTmplt, trngTabsErr } = marketing_camp
    const urlParams = new URLSearchParams(window.location.search)
    const origDesigns = useRef(null);
    const nav = useHistory();

    const handlerBack = () => nav.push(`/campaign/poster`)
    const confirmationModal = (t) => trngModals.set(p => ({ ...p, confirmation: t === 'open' }))

    const __init = async () => {
        trngLoaders.set((p) => ({ ...p, init: true }));
        let res, designs;
        if (urlParams.get('id')) { // FOR CREATE
            res = await rqx.get(`<<tool>>/${env()}/marketing_campaign/posterTemplate`, { id: window.atob(urlParams.get('id')) });
            if (res && res.length > 0) {
                designs = JSON.parse(res[0].designs);
                trngSlctdTmplt.set(res[0]);
            }
        } else if (urlParams.get('pid')) { // FOR UPDATE
            res = await rqx.get(`<<tool>>/${env()}/marketing_campaign/viewPoster`, { id: window.atob(urlParams.get('pid')) });
            if (res && res.length > 0) {
                designs = JSON.parse(res[0].content_design);
                trngSlctdTmplt.set({ id: res[0].id, poster_link: res[0].poster_link, poster_name: res[0].name});
            }
        } else {
            nav.push('/campaign/poster');
        }
        if (designs) {
            trngForm.set(designs);
            trngTabsErr.set((p) => ({ ...p, details: designs.poster_name.value.trim() === '', tabs: designs.poster_name.value.trim() === '' }));
            origDesigns.current = designs;
        }
        trngLoaders.set((p) => ({ ...p, init: false }));
    }

    const handlerTopBtn = (type) => {
        const form = structuredClone(trngForm.data);
        let errors = {};
        const required = ["dis_and_ins", "speakers", "heading", "sub_heading", "title", "button", "time", "date", "location", "poster_name", ];
        required.forEach(v => {
            const field = form[v];
            if (v === 'dis_and_ins') {
                const textOnly = field.value.replace(/<[^>]*>/g, '').trim();
                if (!textOnly) errors[v] = `${v} is required!`;
                form[v].stat = !textOnly;
            } else if (v === 'speakers') {
                field.forEach((spkr, i) => {
                    ['name', 'description', 'company'].forEach((f) => {
                        if (spkr[f].value.trim() === "") {
                            errors[`speaker-${i}-${f}`] = `${f} is required!`;
                            form[v][i][f].stat = spkr[f].value.trim() === ""
                        }
                    })
                })
            } else {
                if (field.value.trim() === "") errors[v] = `${v} is required!`
                form[v].stat = field.value.trim() === ""
            }
        })
        trngForm.set(form)
        if (Object.keys(errors).length !== 0) {
            trngError.set(true)
            return;
        } 
        trngSavingType.set(type)
        trngModals.set(p => ({ ...p, confirmation: true }))
    }

    const submitPoster = async () => {
        trngLoaders.set((p) => ({ ...p, submit: true }))
        const currentData = structuredClone(trngForm.data);
        const originalData = structuredClone(origDesigns.current);
        const nameChangedOnly = (currentData.poster_name.value !== originalData.poster_name.value && isEqual({ ...currentData, poster_name: originalData.poster_name }, originalData));
        const equalToOrgnl = isEqual(currentData, originalData)
        const method = urlParams.get('pid') ? 'update' : urlParams.get('id') ? 'create' : null
        const preview_image = document.getElementById('preview');
        if (!method || !preview_image) return;
        let poster_link;
        if (!equalToOrgnl && !nameChangedOnly) { // function to works with external url links of image from s3
            const imgs = preview_image.querySelectorAll('img'); // get all images from preview_image element
            for (const img of imgs) {
                if (img.src.startsWith("blob:") || img.src.startsWith("data:")) continue; // skip blob:// or data:// URLs
                if (img && img.src) {
                    const baseUrl = img.src.split('?')[0]; // remove any old params
                    img.crossOrigin = 'anonymous'; // important for html-to-image
                    img.src = `${baseUrl}?v=${Date.now()}`; // cache-busting param
                    await new Promise((resolve, reject) => { // await for each image to reload before continuing
                        img.onload = resolve;
                        img.onerror = reject;
                    });
                }
            }
            const dataUrl = await toPng(preview_image);
            const x = await fetch(dataUrl);
            const blob = await x.blob();
            const fileName = `${trngForm.data.poster_name.value}.png`;
            const file = new File([blob], fileName, { type: blob.type });
            poster_link = await S3([file])
        }
        const logos = await Promise.all(
            trngForm.data.logos.map(async (v) => {
                if ('file' in v) {
                    const getLink = await S3([v.file]);
                    return { value: getLink.location };
                }
                return v;
            })
        );
        const speakers = await Promise.all(
            trngForm.data.speakers.map(async (v) => {
                if ('file' in v.img) {
                    const getLink = await S3([v.img.file]);
                    return { ...v, img: { value: getLink.location } };
                }
                return v;
            })
        );
        const violator = { value: trngForm.data.violator.file ? (await S3([trngForm.data.violator.file])).location : trngForm.data.violator.value, show: trngForm.data.violator.show } 
        const bgimage = { value: trngForm.data.bgimage.file ? (await S3([trngForm.data.bgimage.file])).location : trngForm.data.bgimage.value }
        const design = { ...trngForm.data, logos, speakers, violator, bgimage }
        const body = {
            company_id: tool_state.__SESSION.data.uaccess[0].company_id,
            template_id: trngSlctdTmplt.data.id,
            poster_name: design.poster_name.value,
            content_design: design,
            status: trngSavingType.data === 'Save' ? 1 : 2,
            poster_link: (!equalToOrgnl && !nameChangedOnly) ? poster_link.location : trngSlctdTmplt.data.poster_link,
            user_id: tool_state.userId.data,
            id: urlParams.get('pid') ? trngSlctdTmplt.data.id : '',
        }
        const res = await rqx.post(`<<tool>>/${env()}/marketing_campaign/${method}`, body)
        if (res.message === 'success') {
            trngModals.set((p) => ({ ...p, confirmation: false, success: true }))
            trngLoaders.set((p) => ({ ...p, submit: false }))
            nav.push('/campaign/poster')
        }
    }

    useEffect(() => {
        __init();
        // eslint-disable-next-line
    },[])

    return (
        <Box height="100%" display="flex" flexDirection="column" className="overflowY" bgcolor='#ffffff'>
            { trngLoaders.data.init ? 
                <>
                    <Box display="flex" justifyContent="space-between" p="16px" boxShadow={1}>
                        <Skeleton variant="rounded" height={30} width={100} />
                        <Box display="flex" gap="16px">
                            <Skeleton variant="rounded" height={37} width={145} />
                            <Skeleton variant="rounded" height={37} width={145} />
                        </Box>
                    </Box>
                    <Box height="100%" width="100%" display="flex" className="overflowY">
                        <Box height="100%" width={500} boxShadow={1}>
                            <Skeleton variant='rounded' height="100%" />
                        </Box>
                        <Box height="100%" width="100%" p="32px" className="overflowY">
                            <Skeleton variant='rounded' height="100%" />
                        </Box>
                    </Box>
                </>
            :
                <>
                    <Box display="flex" justifyContent="space-between" p="16px" sx={{ borderBottom: '2px solid #F7F8F8' }}>
                        <IconButton onClick={handlerBack} sx={{ border: '2px solid #003F2E', ':hover': { bgcolor: '#edf3eeff' }}}>
                            <ArrowBack sx={{color: '#003022', fontSize: 24}} />
                        </IconButton>
                        <Box display="flex" gap="16px">
                            <Box component={Button} disabled={trngTabsErr.data.tabs} px='24px' variant="contained" bgcolor="#003022" color="#fff" onClick={() => handlerTopBtn('Save')} sx={{ borderRadius: '6px', fontSize: '14px', fontWeight: '600', ':hover': { bgcolor:"#001711", color:"#fff" } }}>Save</Box>
                            <Box component={Button} disabled={trngTabsErr.data.tabs} px='24px' variant="contained" bgcolor="#146eddff" color="#fff" onClick={() => handlerTopBtn('Post')} sx={{ borderRadius: '6px', fontSize: '14px', fontWeight: '600',':hover': { bgcolor:"#0b51a7ff", color:"#fff" } }}>Post</Box>
                        </Box>
                    </Box>
                    <Box height="100%" width="100%" display="flex" className="overflowY">
                        <Box height="100%" width={500} boxShadow={1}>
                            <Tabs/>
                        </Box>
                        <Box height="100%" width="100%" py="32px" className="overflowY">
                            <Preview/>
                        </Box>
                    </Box>
                    { trngModals.data.confirmation && <Confirmation isOpen={trngModals.data.confirmation} cancel={() => confirmationModal('close')} send={() => submitPoster()} disabled={trngLoaders.data.submit} text={`${trngSavingType.data} this Poster?`} btnText={trngSavingType.data}/> }
                    { trngError.data && <InputsErrMsg open={trngError.data} setOpen={(value) => trngError.set(value)} message="Please complete all required fields with valid information!" hideDrtn={null}/> }
                </>
            }
        </Box>
    )
}
